// @ts-nocheck
/* Verbatim port of v1 utilities/dateInputHelpers.js */
export function toDateInputValue(dateLike) {
  if (!dateLike) return '';
  const d = new Date(dateLike);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function todayDateInputValue() {
  return toDateInputValue(new Date());
}

export function clampDateInputValue(value, min, max) {
  if (!value) return value;
  let next = value;
  if (min && next < min) next = min;
  if (max && next > max) next = max;
  return next;
}

export function blockManualDateEntry(e) {
  if (e.key === 'Tab' || e.key === 'Escape' || e.key === 'Enter') return;
  e.preventDefault();
}

export function blockDatePaste(e) {
  e.preventDefault();
}
